import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Scout** (manuale V1, rr. 1420-1426).
 *
 * Sensi acuti e fiuto per il commestibile. Aiuta in guardia, viaggio,
 * accampamento all'aperto.
 */
export const scout: FollowerAbility = {
  id: 'scout',
  label: 'Scout',
  description:
    'Condivide molte cose con le bestie selvatiche: le meno disdicevoli sono i sensi acuti e un fiuto quasi sovrannaturale per tutto ciò che è commestibile nel raggio di miglia. Se non ti guarda ringhiando, è probabile che ti stia indicando guai in arrivo. Sennò, ha fame.',
  ranks: [
    {
      rank: 1,
      trigger: 'Quando uno Scout ti *aiuta* a *fare la guardia*',
      description: 'Prendi +1 al tiro.',
    },
    {
      rank: 2,
      trigger:
        'Quando *intraprendi un viaggio pericoloso* e assegni a uno Scout il ruolo di Ricognitore o di Quartiermastro',
      description:
        'Considera di aver ottenuto un risultato di 7-9 per il ruolo che sta ricoprendo, senza dover tirare i dadi.',
    },
    {
      rank: 3,
      trigger: 'Quando vi *accampate* al di fuori di un centro abitato',
      description:
        'Se ciò è anche solo minimamente plausibile (a discrezione del GM), uno Scout sarà sempre in grado di procurarvi 1d4 *razioni*.',
    },
  ],
};
